export default __webpack_public_path__ + "static/media/iOS-1.8da9cc45.png";